import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVGameAssets} from "../../BenjiKIVGameAssets";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {gsap} from "gsap";
import {BenjiKIVSound} from "../../sound/BenjiKIVSound";
import {SpineUtils} from "../../utils/SpineUtils";

/**
 * Created by Jerker Nord on 2022-12-12.
 */

export class BenjiKIVIntroView extends PIXI.Container implements StageLayer {

    private static SPINE_ANIMATION_NAMES:string[] = ["Intro_1", "Intro_2", "Intro_3"];

    private _introAnimation:PIXI.spine.Spine;
    private _randomIntroTL:gsap.core.Timeline;
    private _fadeOutIntroTL:gsap.core.Timeline;

    constructor() {
        super();
        this.name = "BenjiKIVIntroView";
        this.init();
    }

    private init() {
        this._introAnimation = new PIXI.spine.Spine(BenjiKIV.assetLoader.getSpineAsset(BenjiKIVGameAssets.INTRO_SPINE));
        this._introAnimation.position.set(360, 360);
        this._introAnimation.visible = false;
        this.addChild(this._introAnimation);

        this._fadeOutIntroTL = gsap.timeline({paused : true});
        this._fadeOutIntroTL.add(gsap.to(this._introAnimation, {duration : 0.3, alpha : 0}));
        this._fadeOutIntroTL.add(() => {this._introAnimation.visible = false});
    }

    public playRandomIntro():void {
        BenjiKIV.soundPlayer.playSound(BenjiKIVSound.INTRO_SPLASH);
        this._randomIntroTL = gsap.timeline();
        this._randomIntroTL.add(() => {
            this._introAnimation.visible = true;
            SpineUtils.resetSpineAnimation(this._introAnimation);
        });
        this._randomIntroTL.add(new SpineTween(this._introAnimation, 0, BenjiKIVIntroView.SPINE_ANIMATION_NAMES[MathHelper.randomIntInRange(0, 2)]));
        this._randomIntroTL.add([
            () => {
                for(let i:number = 0; i < BenjiKIV.allReelView.reelModels.length; i++) {
                    if(BenjiKIV.model.initDeadPresidents[i] == true) {
                        BenjiKIV.allReelView.reelModels[i].reelView.doNewGameDeadPresidents();
                    }
                }
            }
        ], "-=0.5");
        this._randomIntroTL.add([
            gsap.to(this._introAnimation, {duration : 0.3, alpha : 0}),
        ]);
        this._randomIntroTL.add(() => {this._introAnimation.visible = false});
    }

    public hideIntro():void {
        if(this._randomIntroTL && this._randomIntroTL.isActive()) {
            this._randomIntroTL.pause();
            this._randomIntroTL.kill();
            this._fadeOutIntroTL.restart();
            BenjiKIV.soundPlayer.stopSound(BenjiKIVSound.INTRO_SPLASH);
        }
    }
}